import StickyBar from './StickyBar';
import { IStickyBar } from './StickBar.interfaces';

export default StickyBar;
export { StickyBar, IStickyBar };
